import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { currentSearchResults, selectSearchResult } from "@/components/Search/searchSlice";
import { useAccount } from '@/hooks/useAccount';
import type { SearchResult, SearchResultType } from "@/types";
import { Box, Divider, ScrollArea, Stack, Text } from "@mantine/core";

const RESULT_TYPE_LABELS: Record<SearchResultType, string> = {
    address: 'Parcel Address',
    owner: 'Owner',
    apn: 'APN',
    geocode: 'Geocode',
    none: 'Geocode',
};

interface SearchResultsProps {
    onSelectSearchResult: () => void;
}

const SearchResults:React.FC<SearchResultsProps> = ({onSelectSearchResult}) => {
    const dispatch = useAppDispatch();
    const { userId } = useAccount();
    const searchResults = useAppSelector(currentSearchResults);
    const searchResultClickHandler = (searchResult: SearchResult) => {
        dispatch(selectSearchResult({ searchResult, ownerId: userId }));
        onSelectSearchResult();
    }
    return (
        <ScrollArea h='100%' py={5}>
            <Stack gap={3} mx="md">
                {searchResults.map((result:SearchResult, i: number) => (
                    <Box key={i} onClick={() => searchResultClickHandler(result)}>
                        <Text size="sm" fw="800">{result.result}</Text>
                        <Text size="xs">{`${RESULT_TYPE_LABELS[result.type]} (${result.county})`}</Text>
                        {
                            searchResults.length - 1 !== i && <Divider m={0} />
                        }
                    </Box>
                ))}
            </Stack>
        </ScrollArea>
    )
}

export default SearchResults;
